import { parse } from "qs";

import { Query } from "@/custom-types/Query";

/**
 * A utility for parsing the asPath string provided by Next router.
 * @deprecated use hooks/useParsedQueryString instead
 * @param asPath - usually from useRouter via next/router
 * @returns {ParsedNextRouter} - contains hash, path, and parsed query string
 */
const parseNextRouterAsPath = <T = Query>(asPath: string) => {
  const [url, hash] = asPath.split("#");
  const [path, query] = url.split("?");

  return { hash, path, query: parse(query) as T };
};

export default parseNextRouterAsPath;
